// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_QsT","cls2":"ActiveState-cls2_v72 ActiveState-cls1_QsT"};